<template>
  <transition name="pa-simple-fade" @after-enter="handleAfterEnter">
    <section class="hero is-fullheight pa-landscape-protector" v-if="isShow">
      <div class="hero-body">
        <div class="container">
          <transition name="card-wrap">
            <PACard v-if="isShowCard" />
          </transition>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import PACard from '@/components/Parts/PACard/PACard.vue';

export default {
  name       : 'PALandScapeProtector',
  
  props      : {
    isRequireProtect   : {
      default: false
    }
  },

  components : {
    PACard
  },

  data(){
    return {
      isShow  : false,
      isShowCard : false
    };
  },

  watch : {
    isRequireProtect : {
      handler(value){
        this.isShow = value;
      },
      immediate: true
    }
  },

  methods : {
    handleAfterEnter(){
      this.isShowCard = true;
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.card-wrap{
  &-enter-active{
    transition: opacity .8s ease-in;
  }

  &-leave-active{
    transition: opacity .5s ease-in-out;
  }

  &-enter, &-leave-to{
    opacity:0;
  }
}

.pa-landscape-protector{
  z-index: 200;
  position: fixed;
  top:0;
  left:0;
  background-color:$body-background-primary;
  background:radial-gradient($body-background-semi-light-darker 0%, $body-background-primary 70%);
  min-width: 100vw;

  &.hero{
    &.is-fullheight{
      .hero-body{
        padding:0;
      }
    }
  }
}
</style>